(() => {
  'use strict';

  const SCRIPT_ID = 'aura-revi-loader';

  const SCRIPT_URL =
    'https://df81sh4kfcckj.cloudfront.net/revi-loader.js?siteKey=sFGH3I3XHK1km7N7aEQ0qrFlDErFDfbJRC3CJv2J';

  const RESTRICTED_ROUTE =
    /(?:^|\/)(?:account|challenge|checkout|password)(?:\/|$)/i;

  if (RESTRICTED_ROUTE.test(window.location.pathname)) {
    return;
  }

  function hasMarketingConsent() {
    const privacy = window.Shopify?.customerPrivacy;

    if (
      !privacy ||
      typeof privacy.marketingAllowed !== 'function'
    ) {
      return false;
    }

    return privacy.marketingAllowed() === true;
  }

  function hasPasswordField() {
    return document.querySelector('input[type="password"]') !== null;
  }

  function loadRevi() {
    if (!hasMarketingConsent()) return;
    if (hasPasswordField()) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');

    script.id = SCRIPT_ID;
    script.src = SCRIPT_URL;
    script.async = true;

    document.head.appendChild(script);
  }

  function initialize() {
    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== 'function'
    ) {
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      (error) => {
        if (error) return;

        document.addEventListener(
          'visitorConsentCollected',
          loadRevi
        );

        document.addEventListener(
          'trackingConsentAccepted',
          loadRevi
        );

        loadRevi();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
